import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth, type Business } from '../AuthContext';
import archLogo from '../assets/arch-logo.png';
import './Login.css';

export default function BusinessPicker() {
  const { pendingBusinesses, selectBusiness, logout } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSelect = async (business: Business) => {
    setError(null);
    setLoading(true);
    try {
      await selectBusiness(business);
      navigate('/');
    } catch (e: any) {
      setError(e?.message || 'Failed to select business');
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  if (!pendingBusinesses) {
    navigate('/');
    return null;
  }

  return (
    <div className="tv-login-page">
      <div className="tv-login-container">
        <div className="tv-login-card">
          <div className="tv-login-brand">
            <img src={archLogo} alt="Attractis" className="tv-login-logo" decoding="async" />
            <h1 className="tv-login-title">Select Business</h1>
            <p className="tv-login-subtitle">Table Vision</p>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {pendingBusinesses.map((biz) => (
              <button
                key={biz.id}
                className="tv-login-btn"
                style={{ textAlign: 'left', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                disabled={loading}
                onClick={() => handleSelect(biz)}
              >
                <span>{biz.name}</span>
                <span style={{ fontSize: 11, opacity: 0.6, fontWeight: 400, textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                  {biz.role}
                </span>
              </button>
            ))}
          </div>

          {error && <div className="tv-login-error" style={{ marginTop: 16 }}>{error}</div>}

          <button
            onClick={handleLogout}
            style={{
              marginTop: 20,
              background: 'none',
              border: 'none',
              color: 'var(--color-secondary-600)',
              fontSize: 13,
              cursor: 'pointer',
              textAlign: 'center',
              width: '100%',
              padding: '4px 0',
            }}
          >
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
